function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.22 22.805h-7.305c-.553 0-1.002.41-1.002.918 0 .507.449.918 1.002.918h7.305c.553 0 1.002-.41 1.002-.918 0-.507-.449-.918-1.002-.918z",
  fill: "#6F62FF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.763 20.114c.11.068.217.14.32.215.854.62 1.467 1.493 1.728 2.458.192.709.02 1.445-.471 2.02-.234.275-.537.502-.875.657-.356.164-.756.25-1.155.25h-4.587c-.4 0-.799-.086-1.155-.25a2.565 2.565 0 0 1-.875-.656 2.195 2.195 0 0 1-.471-2.021c.26-.965.874-1.838 1.727-2.458a4.94 4.94 0 0 1 .321-.215 3.43 3.43 0 0 1-.73-1.024 3.192 3.192 0 0 1 0-2.693c.19-.412.463-.782.809-1.099.345-.317.749-.566 1.198-.74.466-.18.96-.272 1.47-.272.508 0 1.002.091 1.469.272.45.174.852.423 1.198.74s.618.687.808 1.099a3.192 3.192 0 0 1 0 2.693 3.43 3.43 0 0 1-.73 1.024zm-.978-2.37c0-.896-.792-1.622-1.769-1.622-.977 0-1.769.726-1.768 1.621 0 1.366 1.845 2.127 2.958 1.2.367-.305.58-.745.58-1.2zm-4.618 5.485c-.09.33.185.649.556.649h4.586c.372 0 .646-.32.557-.65a2.513 2.513 0 0 0-.153-.415c-.727-1.545-2.925-2.11-4.421-1.112a2.71 2.71 0 0 0-1.125 1.527z",
  fill: "#6F62FF"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.22 19.042h-7.305c-.553 0-1.002.411-1.002.919 0 .507.449.918 1.002.918h7.305c.553 0 1.002-.411 1.002-.918 0-.508-.449-.919-1.002-.919zM21.915 15.28h7.305c.553 0 1.002.411 1.002.918 0 .507-.449.919-1.002.919h-7.305c-.553 0-1.002-.412-1.002-.919 0-.507.449-.918 1.002-.918z",
  fill: "#6F62FF"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.28 11H8.72C7.22 11 6 12.118 6 13.493v13.014C6 27.882 7.22 29 8.72 29h22.56c1.5 0 2.72-1.118 2.72-2.493V13.493C34 12.118 32.78 11 31.28 11zm.716 15.507c0 .362-.32.656-.716.656H8.72c-.395 0-.716-.294-.716-.656V13.493c0-.363.32-.656.716-.656h22.56c.395 0 .716.293.716.656v13.014z",
  fill: "currentColor"
});

var SvgAudienceGeneral = function SvgAudienceGeneral(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    width: 40,
    height: 40,
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAudienceGeneral, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/audience_general.47727ffb.svg";
export { ForwardRef as ReactComponent };